// extracted by mini-css-extract-plugin
export var divider = "_4g-0";
export var dividerText = "_4g-1";